import {
  IGetUsersViewedMessageRequest,
  IGetUsersViewedMessageResponse,
} from 'APP/model/message/messageModel.types';
import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

export async function getUsersViewedMessage(
  data: IGetUsersViewedMessageRequest
): Promise<IGetUsersViewedMessageResponse> {
  try {
    const result = await messageModel.getUsersViewedMessage(data);

    const group = Entities.GroupsStore.getGroupById(data.groupId);
    if (group) {
      const message = group.messagesStore.getMessageById(data.messageId);
      if (message && message.views < result.userIds.length) {
        message.setViews(result.userIds.length.toString());
      }
    }

    return result;
  } catch {
    return { userIds: [] };
  }
}
